import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungKaiserslautern() {
  return (
    <CityPageTemplate
      city="Kaiserslautern"
      slug="kaiserslautern"
      intro="Kaiserslautern in der Pfalz – wir bringen Deine Finanzen genauso in die Bundesliga wie Dein Lieblingsverein."
      description="Unabhängige & digitale Finanzberatung für Kaiserslautern: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
